var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217.842,
    height: 361.955,
    viewBox: "0 0 217.842 361.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 3.557,
    x2: 0.5,
    y2: -2.143,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77b71c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94ce41"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5669",
    transform: "translate(1.25 -12.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5671",
    transform: "translate(0 14.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5673",
    d: "M273.143,136.409c0,41.031-43.4,94.29-76.1,123.359-37.218-.556-22.779-.723-65.079.612C99.752,231.4,57.8,177.59,57.8,136.409a107.671,107.671,0,0,1,215.342,0Z",
    transform: "translate(-57.801 -28.873)",
    fill: "#f1693e",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5675",
    d: "M212.645,111.247c0,40.834-30.12,93.783-52.989,122.936-27.879.014-16.43-.15-46.384.417-22.509-29.107-51.5-82.458-51.5-123.353,0-59.342,33.8-107.5,75.438-107.5,35.315,0,64.986,34.641,73.2,81.36A152.4,152.4,0,0,1,212.645,111.247Z",
    transform: "translate(-29.444 -3.744)",
    fill: "#f7e95a",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5677",
    d: "M136.37,111.148c0,40.726-11.381,93.518-20.035,122.656-16.87.117.441-.006-17.7.175-8.511-29.143-19.4-82.157-19.4-122.831,0-59.262,12.8-107.357,28.57-107.357S136.37,51.887,136.37,111.148Z",
    transform: "translate(-0.743 -3.662)",
    fill: "#28ade0",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5679",
    transform: "translate(76.175 245.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5681",
    d: "M77.566,89.116a766.586,766.586,0,0,1,13.018,78.122",
    transform: "translate(-77.566 -89.11)",
    fill: "none",
    stroke: "#37383c",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5683",
    d: "M85.031,89.114l7,77.949",
    transform: "translate(-65.294 -89.114)",
    fill: "none",
    stroke: "#37383c",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5689",
    d: "M94.944,89.141l-3.019,77.825",
    transform: "translate(-53.961 -89.063)",
    fill: "none",
    stroke: "#37383c",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5691",
    d: "M107,89.118A660.638,660.638,0,0,0,96.2,167.1",
    transform: "translate(-46.942 -89.105)",
    fill: "none",
    stroke: "#37383c",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "path5693",
    d: "M102.1,263.289l-2-2.7,67.062.078-1.49,3.181Z",
    transform: "translate(-27.303 -8.848)",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5695",
    d: "M83.045,120.561a4.738,4.738,0,0,0,0,9.438h1.533a13.509,13.509,0,0,0-.11,1.822v22.455c0,9.145,6.74,16.5,15.093,16.5h19.77c8.353,0,15.09-7.355,15.09-16.5V131.821a13.505,13.505,0,0,0-.11-1.822h1.536a4.738,4.738,0,0,0,0-9.438Z",
    transform: "translate(-1.565 202.829)",
    fill: "#70544b",
    stroke: "#37383c",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5671-2",
    "data-name": "g5671",
    transform: "translate(32.327 14.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5673-2",
    "data-name": "path5673",
    d: "M273.143,136.409c0,41.031-43.4,94.29-76.1,123.359-37.218-.556-91-230.867-31.573-230.867A107.642,107.642,0,0,1,273.143,136.409Z",
    transform: "translate(-90.128 -28.873)",
    fill: "#28acdf",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5675-2",
    "data-name": "path5675",
    d: "M212.645,111.247c0,40.834-30.12,93.783-52.989,122.936-27.879.014-16.43-.15-46.384.417-22.509-29.107-51.5-82.458-51.5-123.353,0-59.342,33.8-107.5,75.438-107.5,35.315,0,64.986,34.641,73.2,81.36A152.4,152.4,0,0,1,212.645,111.247Z",
    transform: "translate(-61.771 -3.744)",
    fill: "#f3bd3e",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5675-3",
    "data-name": "path5675",
    d: "M212.645,111.247c0,40.834-30.12,93.783-52.989,122.936-20.073.01-19.758-.072-29.481.1C126.8,234.34,95.568,3.744,137.21,3.744c35.315,0,64.986,34.641,73.2,81.36A152.4,152.4,0,0,1,212.645,111.247Z",
    transform: "translate(-61.771 -3.744)",
    fill: "#30c165",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5677-2",
    "data-name": "path5677",
    d: "M136.37,111.148c0,40.726-11.381,93.518-20.035,122.656-16.87.117.441-.006-17.7.175-8.511-29.143-19.4-82.157-19.4-122.831,0-59.262,12.8-107.357,28.57-107.357S136.37,51.887,136.37,111.148Z",
    transform: "translate(-33.071 -3.662)",
    fill: "#f7e95a",
    stroke: "#37383c",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.6e8df68a27f09b8037b61ce8527f3a6c.svg";
export { ForwardRef as ReactComponent };